import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import Image from 'next/image'
import { DifferenceItemRoot } from './DifferenceItem.styles'

type DifferenceItemProps = {
  image: string
  title: string
  description: string
}

export const DifferenceItem = ({ image, title, description }: DifferenceItemProps) => {
  return (
    <DifferenceItemRoot>
      <Stack direction="column">
        <Image src={image} />

        <Text as="p" size="headline" weight="bold" align="center">
          {title}
        </Text>

        <Text as="p" align="center">
          {description}
        </Text>
      </Stack>
    </DifferenceItemRoot>
  )
}
